import { FC, PropsWithChildren } from 'react';
import EnaraLogo from '../icons/EnaraLogo';
import './core-layout.css';

type Props = {
  containerClassName?: string;
  logo?: false;
};

const CoreLayout: FC<PropsWithChildren<Props>> = ({ children, containerClassName, logo }) => {
  return (
    <div className={`core-container ${containerClassName || ''}`}>
      {logo !== false ? <EnaraLogo /> : null}
      {children}
    </div>
  );
};

export default CoreLayout;
